var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTr45(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2894,
    height: 544,
    viewBox: "0 0 2894 544",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1575_1902)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 271.312,
    cy: 272.25,
    r: 271.312,
    fill: "#00AA6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 859.156,
    cy: 272.25,
    r: 271.312,
    fill: "#00AA6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1447,
    cy: 272.25,
    r: 271.312,
    fill: "#00AA6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2034.84,
    cy: 272.25,
    r: 271.312,
    fill: "#00AA6C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2871.39 272.25C2871.39 409.605 2760.04 520.953 2622.69 520.953V23.5469C2760.04 23.5469 2871.39 134.895 2871.39 272.25ZM2622.69 543.562C2772.53 543.562 2894 422.092 2894 272.25C2894 122.408 2772.53 0.9375 2622.69 0.9375C2472.85 0.9375 2351.38 122.408 2351.38 272.25C2351.38 422.092 2472.85 543.562 2622.69 543.562Z",
    fill: "#00AA6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1575_1902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2894,
    height: 542.625,
    fill: "white",
    transform: "translate(0 0.9375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr45);
export default __webpack_public_path__ + "static/media/tr-4.5.28516486ec652f347a86b3757c9ed8b4.svg";
export { ForwardRef as ReactComponent };